(function () {
  if (window.__variantTableGlobalBound) {
    document.querySelectorAll('[data-variant-table-options], [data-variant-table]').forEach((root) => {
      refreshPrice(root);
    });
    return;
  }

  window.__variantTableGlobalBound = true;

  // --- helpers ---
  const getMainArticle = (el) => el?.closest('article[data-form-id]');

  const getMainForm = (article) => {
    const id = article?.getAttribute('data-form-id');
    return id ? document.getElementById(id) : null;
  };

  const getArticle = (el) => el?.closest('article[data-form-id]');

  const getVariantIdFromTruth = (article) => {
    if (!article) return null;

    // 1) hidden variant-id custom
    const v = article.querySelector('input[name="variant-id"]');
    if (v?.value) return v.value;

    // 2) champ standard Shopify
    const mainFormId = article.getAttribute('data-form-id');
    const mainForm = mainFormId ? document.getElementById(mainFormId) : null;
    const idInput = mainForm?.querySelector('input[name="id"], select[name="id"]');
    if (idInput?.value) return idInput.value;

    // 3) fallback installments
    const inst = article.querySelector('form.f8pr-product-form-installment input[name="id"]');
    if (inst?.value) return inst.value;

    return null;
  };

  const updateMainPriceFromVariantId = (article, variantId) => {
    if (!article || !variantId) return;

    const row = article.querySelector(`[data-variant-row][data-variant-id="${variantId}"]`);
    if (!row) return;

    const price = row.getAttribute('data-price') || '';
    const compare = row.getAttribute('data-compare') || '';

    const priceEl = article.querySelector('[data-main-price]');
    if (!priceEl) return;

    const currentEl = priceEl.querySelector('.current-price');
    if (currentEl) currentEl.textContent = price;

    let oldEl = priceEl.querySelector('.old-price');
    if (compare) {
      if (!oldEl) {
        priceEl.insertAdjacentHTML('afterbegin', `<span class="old-price"></span>&nbsp;`);
        oldEl = priceEl.querySelector('.old-price');
      }
      oldEl.textContent = compare;
    } else if (oldEl) {
      oldEl.remove();
    }

    const unitEl = priceEl.querySelector('.unit-price');
    if (unitEl) unitEl.style.display = 'none';
  };

  function refreshPrice(fromEl) {
    const article = getArticle(fromEl);
    const variantId = getVariantIdFromTruth(article);
    updateMainPriceFromVariantId(article, variantId);
  }

  const syncVariantEverywhere = (root, variantId) => {
    if (!root || !variantId) return;

    const article = getMainArticle(root);
    const mainForm = getMainForm(article);

    // 1) hidden variant-id custom
    const vInput =
      article?.querySelector('#variant-id-' + article.getAttribute('data-template')) ||
      article?.querySelector('input[name="variant-id"]');

    if (vInput) {
      vInput.value = String(variantId);
      vInput.dispatchEvent(new Event('input', { bubbles: true }));
      vInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // 2) main product form
    if (mainForm) {
      const idInput = mainForm.querySelector('input[name="id"], select[name="id"]');
      if (idInput) {
        idInput.value = String(variantId);
        idInput.dispatchEvent(new Event('input', { bubbles: true }));
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      mainForm.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // 3) installments
    const installmentIdInput = article?.querySelector('form.f8pr-product-form-installment input[name="id"]');
    if (installmentIdInput) {
      installmentIdInput.value = String(variantId);
      installmentIdInput.dispatchEvent(new Event('input', { bubbles: true }));
      installmentIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // 4) state classes
    const box = root.closest('.f8pr-variant-selection');
    if (box) box.setAttribute('data-current-variant', String(variantId));

    const f8pr = root.closest('.f8pr');
    if (f8pr) f8pr.classList.remove('unavailable');

    updateMainPriceFromVariantId(getArticle(root), variantId);
  };

  // [Bohm] Option « Commencer par la 1re image du produit » (data-keep-first-media sur l'article,
  // posé par main-product.liquid). Tant que le client n'a pas touché au sélecteur de variantes,
  // la synchronisation automatique du chargement ne doit pas faire défiler la galerie.
  const keepFirstMedia = (root) => {
    const article = getArticle(root);
    return !!article && article.hasAttribute('data-keep-first-media') && !article.__variantPickedByUser;
  };

  const ensureOpt2CheckedAndSync = (root) => {
    if (!root) return;

    const tables = Array.from(root.querySelectorAll('[data-option1-table]'));
    if (!tables.length) return; // rien à synchroniser pour les tables simples

    const activeTable =
      tables.find((t) => !t.hidden && t.getAttribute('hidden') === null) ||
      tables.find((t) => !t.hidden);

    if (!activeTable) return;

    let opt2 = activeTable.querySelector('input.variant-table__opt2-radio:checked');
    if (!opt2) {
      const firstEnabled = activeTable.querySelector('input.variant-table__opt2-radio:not([disabled])');
      if (firstEnabled) {
        firstEnabled.checked = true;
        firstEnabled.dispatchEvent(new Event('change', { bubbles: true }));
        opt2 = firstEnabled;
      }
    }

    if (!opt2) return;

    const row = opt2.closest('[data-variant-row]');
    if (!row) return;

    // [Bohm] Le clic simulé sur la ligne déclenche aussi le défilement de la galerie
    // (écouteur du thème dans custom-async.js). Avec l'option « 1re image », on fait
    // la même sélection sans ce clic : même événement change que celui envoyé par le clic.
    if (keepFirstMedia(root)) {
      if (!opt2.disabled) {
        opt2.checked = true;
        opt2.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    row.click();
  };

  const ensureOpt3CheckedAndSync = (root, option1Value = null, option2Value = null) => {
    if (!root) return;

    const tables = Array.from(root.querySelectorAll('[data-option3-table]'));
    if (!tables.length) return;

    let activeTable = null;

    if (option1Value && option2Value) {
      activeTable = tables.find((table) => {
        return (
          table.getAttribute('data-option1-table') === option1Value &&
          table.getAttribute('data-option2-table') === option2Value
        );
      });
    }

    if (!activeTable) {
      activeTable =
        tables.find((table) => !table.hidden && table.getAttribute('hidden') === null) ||
        tables.find((table) => !table.hidden);
    }

    if (!activeTable) return;

    // Nettoie tous les radios des tables cachées pour éviter qu'une ancienne taille reste checked.
    tables.forEach((table) => {
      const isActiveTable = table === activeTable;

      table.querySelectorAll('input.variant-table__opt3-radio').forEach((radio) => {
        radio.disabled = !isActiveTable || radio.classList.contains('disabled');

        if (!isActiveTable) {
          radio.checked = false;
        }
      });
    });

    let opt3 = activeTable.querySelector('input.variant-table__opt3-radio:checked:not([disabled])');

    if (!opt3) {
      opt3 = activeTable.querySelector('input.variant-table__opt3-radio:not([disabled])');
      if (opt3) {
        opt3.checked = true;
      }
    }

    if (!opt3) return;

    const row = opt3.closest('[data-variant-row]');
    const variantId = row?.getAttribute('data-variant-id');

    if (variantId) {
      syncVariantEverywhere(root, variantId);
      updateMainPriceFromVariantId(getArticle(root), variantId);
    }
  };

  const updateOption1Tables = (root, value) => {
    if (!root) return;

    const tables = root.querySelectorAll('[data-option1-table]');
    if (!tables.length) return;

    tables.forEach((table) => {
      const match = table.getAttribute('data-option1-table') === value;
      table.hidden = !match;

      table.querySelectorAll('input.variant-table__opt2-radio').forEach((radio) => {
        radio.disabled = !match;
        if (!match) radio.checked = false;
      });
    });

    requestAnimationFrame(() => ensureOpt2CheckedAndSync(root));
  };

  const getVisibleOption2Group = (root) => {
    if (!root) return null;

    return (
      Array.from(root.querySelectorAll('[data-option2-group]')).find((group) => {
        return !group.hidden && group.getAttribute('hidden') === null;
      }) ||
      Array.from(root.querySelectorAll('[data-option2-group]')).find((group) => !group.hidden) ||
      null
    );
  };

  const updateOption2Groups = (root, option1Value) => {
    if (!root) return;

    const groups = root.querySelectorAll('[data-option2-group]');
    if (!groups.length) return;

    groups.forEach((group) => {
      const match = group.getAttribute('data-option2-group') === option1Value;
      group.hidden = !match;

      group.querySelectorAll('[data-option2-btn]').forEach((radio) => {
        radio.disabled = !match || radio.classList.contains('disabled');
        if (!match) radio.checked = false;
      });
    });

    const activeGroup = getVisibleOption2Group(root);
    if (!activeGroup) return;

    let opt2 = activeGroup.querySelector('[data-option2-btn]:checked:not([disabled])');

    if (!opt2) {
      opt2 = activeGroup.querySelector('[data-option2-btn]:not([disabled])');
      if (opt2) opt2.checked = true;
    }

    if (opt2) {
      updateOption3Tables(
        root,
        opt2.getAttribute('data-option1'),
        opt2.getAttribute('data-option2')
      );
    }
  };

  const updateOption3Tables = (root, option1Value, option2Value) => {
    if (!root) return;

    const tables = root.querySelectorAll('[data-option3-table]');
    if (!tables.length) return;

    tables.forEach((table) => {
      const match =
        table.getAttribute('data-option1-table') === option1Value &&
        table.getAttribute('data-option2-table') === option2Value;

      table.hidden = !match;

      table.querySelectorAll('input.variant-table__opt3-radio').forEach((radio) => {
        radio.disabled = !match || radio.classList.contains('disabled');

        if (!match) {
          radio.checked = false;
        }
      });
    });

    ensureOpt3CheckedAndSync(root, option1Value, option2Value);
  };

  const syncOption2Selection = (option2Btn) => {
    if (!option2Btn || option2Btn.disabled) return;

    const root = option2Btn.closest('[data-variant-table-options]');
    if (!root?.matches('[data-variant-table-three]')) return;

    const option1Value = option2Btn.getAttribute('data-option1');
    const option2Value = option2Btn.getAttribute('data-option2');

    if (!option1Value || !option2Value) return;

    const applySelection = () => {
      const activeGroup = getVisibleOption2Group(root);
      const option2Radios = activeGroup
        ? activeGroup.querySelectorAll('[data-option2-btn]')
        : root.querySelectorAll('[data-option2-btn]');

      option2Radios.forEach((radio) => {
        const isTarget =
          radio.getAttribute('data-option1') === option1Value &&
          radio.getAttribute('data-option2') === option2Value;

        radio.checked = isTarget;
      });

      updateOption3Tables(root, option1Value, option2Value);
    };

    applySelection();
    requestAnimationFrame(applySelection);
    setTimeout(applySelection, 0);
    setTimeout(applySelection, 50);
    setTimeout(applySelection, 150);
  };

  const initRoot = (root) => {
    if (!root || root.__vtInited) return;
    root.__vtInited = true;

    // Cas table avec options groupées : 2 niveaux ou 3 niveaux
    if (root.matches('[data-variant-table-options]')) {
      const checkedOpt1 = root.querySelector('[data-option1-btn]:checked');
      const firstOpt1 = root.querySelector('[data-option1-btn]');

      const opt1ToUse = checkedOpt1 || firstOpt1;

      if (opt1ToUse && !checkedOpt1) {
        opt1ToUse.checked = true;
      }

      if (root.matches('[data-variant-table-three]')) {
        if (opt1ToUse) {
          updateOption2Groups(root, opt1ToUse.getAttribute('data-option1'));
        }

        setTimeout(() => ensureOpt3CheckedAndSync(root), 0);
        setTimeout(() => ensureOpt3CheckedAndSync(root), 50);
        setTimeout(() => ensureOpt3CheckedAndSync(root), 200);
        return;
      }

      if (opt1ToUse) {
        updateOption1Tables(root, opt1ToUse.getAttribute('data-option1'));
      }

      setTimeout(() => ensureOpt2CheckedAndSync(root), 0);
      setTimeout(() => ensureOpt2CheckedAndSync(root), 50);
      setTimeout(() => ensureOpt2CheckedAndSync(root), 200);
      return;
    }

    // Cas simple : juste refresh price initial si besoin
    if (root.matches('[data-variant-table]')) {
      refreshPrice(root);
    }
  };

  // --- Global event listeners ---

  // [Bohm] Option « 1re image » : dès que le client agit lui-même sur le sélecteur de variantes
  // (souris, doigt ou clavier), on reprend le comportement normal (la galerie suit la variante).
  // e.isTrusted écarte les clics et changements simulés par le code au chargement.
  ['pointerdown', 'keydown'].forEach((type) => {
    document.addEventListener(type, (e) => {
      if (!e.isTrusted) return;
      const selection = e.target.closest?.('.f8pr-variant-selection');
      if (!selection) return;
      const article = getArticle(selection);
      if (article) article.__variantPickedByUser = true;
    }, true);
  });

  // Capture anticipée du clic sur la couleur en mode 3 niveaux.
  // Objectif : mettre à jour la taille active avant que le thème ne valide la combinaison.
  document.addEventListener('click', (e) => {
    let option2Btn = e.target.closest('[data-option2-btn]');

    if (!option2Btn) {
      const label = e.target.closest('label[for]');
      if (label) {
        const input = document.getElementById(label.getAttribute('for'));
        if (input?.matches?.('[data-option2-btn]')) {
          option2Btn = input;
        }
      }
    }

    if (option2Btn) {
      syncOption2Selection(option2Btn);
    }
  }, true);

  document.addEventListener('change', (e) => {
    const opt1 = e.target.closest('[data-option1-btn]');
    if (opt1) {
      const root = opt1.closest('[data-variant-table-options]');

      if (root?.matches('[data-variant-table-three]')) {
        updateOption2Groups(root, opt1.getAttribute('data-option1'));
      } else {
        updateOption1Tables(root, opt1.getAttribute('data-option1'));
      }

      return;
    }

    const option2Btn = e.target.closest('[data-option2-btn]');
    if (option2Btn) {
      syncOption2Selection(option2Btn);
      return;
    }

    const opt2 = e.target.closest('input.variant-table__opt2-radio');
    if (opt2) {
      const root = opt2.closest('[data-variant-table-options]');
      const row = opt2.closest('[data-variant-row]');
      const variantId = row?.getAttribute('data-variant-id');

      if (root && variantId) {
        syncVariantEverywhere(root, variantId);
        updateMainPriceFromVariantId(getArticle(root), variantId);
      } else {
        refreshPrice(opt2);
      }
      return;
    }

    const opt3 = e.target.closest('input.variant-table__opt3-radio');
    if (opt3) {
      const root = opt3.closest('[data-variant-table-options]');
      const row = opt3.closest('[data-variant-row]');
      const variantId = row?.getAttribute('data-variant-id');

      if (root && variantId) {
        syncVariantEverywhere(root, variantId);
        updateMainPriceFromVariantId(getArticle(root), variantId);
      } else {
        refreshPrice(opt3);
      }

      return;
    }

    const simpleRadio = e.target.closest('input.variant-table__simple-radio');
    if (simpleRadio) {
      const row = simpleRadio.closest('[data-variant-row]');
      const root =
        simpleRadio.closest('[data-variant-table]') ||
        simpleRadio.closest('[data-variant-table-options]');
      const variantId = row?.getAttribute('data-variant-id');

      if (root && variantId) {
        syncVariantEverywhere(root, variantId);
        updateMainPriceFromVariantId(getArticle(root), variantId);
      } else {
        refreshPrice(simpleRadio);
      }
      return;
    }
  });

  document.addEventListener('click', (e) => {
    const row = e.target.closest('[data-variant-row]');
    if (!row) return;

    if (
      e.target.closest('[data-row-add-to-cart]') ||
      e.target.closest('.variant-table__qty') ||
      e.target.closest('label')
    ) {
      return;
    }

    const variantId = row.getAttribute('data-variant-id');
    if (!variantId) return;

    // Sélection de la variante liée à la ligne : opt3, opt2 ou simple selon le mode
    const radio =
      row.querySelector('input.variant-table__opt3-radio') ||
      row.querySelector('input.variant-table__opt2-radio') ||
      row.querySelector('input.variant-table__simple-radio');

    if (radio && !radio.disabled) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    // Fallback : ligne sans radio, synchronisation directe
    const root =
      row.closest('[data-variant-table-options]') ||
      row.closest('[data-variant-table]');

    if (root) {
      syncVariantEverywhere(root, variantId);
    }
  });

  document.addEventListener('focusin', (e) => {
    const qtyInput = e.target.closest('.variant-table__qty');
    if (!qtyInput) return;

    const row = qtyInput.closest('[data-variant-row]');
    if (!row) return;

    const radio =
      row.querySelector('input.variant-table__opt3-radio') ||
      row.querySelector('input.variant-table__opt2-radio') ||
      row.querySelector('input.variant-table__simple-radio');

    // Sélection automatique de la variante quand on focus la quantité
    if (radio) {
      if (!radio.disabled && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    // Fallback : ligne sans radio
    const variantId = row.getAttribute('data-variant-id');
    const root =
      row.closest('[data-variant-table-options]') ||
      row.closest('[data-variant-table]');

    if (root && variantId) {
      syncVariantEverywhere(root, variantId);
    }
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-row-add-to-cart]');
    if (!btn) return;

    e.stopPropagation();

    const article = btn.closest('article[data-form-id]');
    const formId = article?.getAttribute('data-form-id');
    const mainForm = formId ? document.getElementById(formId) : null;
    if (!mainForm) return;

    const variantId = btn.getAttribute('data-variant-id');
    const row = btn.closest('[data-variant-row]');
    // Quantité lue dans la ligne elle-même : la QuickView réécrit les id
    const qtyInput = row?.querySelector('.variant-table__qty');
    if (qtyInput && typeof normalizePackQty === 'function') {
      normalizePackQty(qtyInput);
    }
    const qtyMin = parseInt(qtyInput?.min || '1', 10) || 1;
    const qty = Math.max(qtyMin, parseInt(qtyInput?.value || String(qtyMin), 10) || qtyMin);

    const radio =
      row?.querySelector('input.variant-table__opt3-radio') ||
      row?.querySelector('input.variant-table__opt2-radio') ||
      row?.querySelector('input.variant-table__simple-radio');

    if (radio && !radio.disabled) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      const root =
        row?.closest('[data-variant-table-options]') ||
        row?.closest('[data-variant-table]');

      if (root && variantId) {
        syncVariantEverywhere(root, variantId);
      }
    }

    const idInput = mainForm.querySelector('input[name="id"], select[name="id"]');
    if (idInput) {
      idInput.value = String(variantId);
      idInput.dispatchEvent(new Event('input', { bubbles: true }));
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const qtyMain = mainForm.querySelector('input[name="quantity"]') || mainForm.querySelector('[data-main-qty]');
    if (qtyMain) {
      qtyMain.value = String(qty);
      qtyMain.dispatchEvent(new Event('input', { bubbles: true }));
      qtyMain.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('input[name="variant-id"], form[id^="main-product-form-"] input[name="id"]')) {
      refreshPrice(e.target);
    }
  });

  // --- Init existing roots now ---
  document.querySelectorAll('[data-variant-table-options], [data-variant-table]').forEach(initRoot);

  // --- Re-init roots added later ---
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;

        if (node.matches?.('[data-variant-table-options], [data-variant-table]')) initRoot(node);
        node.querySelectorAll?.('[data-variant-table-options], [data-variant-table]').forEach(initRoot);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-variant-table-options], [data-variant-table]').forEach(initRoot);
  });
})();

/* Copie de la référence produit (fiche produit + QuickView) : écoute globale, donc valable aussi
   pour les QuickView ouvertes après le chargement */
(function () {
  if (window.__copyReferenceBound) return;
  window.__copyReferenceBound = true;

  const TEXT_DEFAULT = 'Copy';
  const TEXT_DONE = 'Copied !';
  const TEXT_FAIL = 'Copy failed';

  // Secours si l'API presse-papiers est refusée (aperçu de l'éditeur, ancien navigateur…)
  function fallbackCopy(text) {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
    document.body.appendChild(area);
    area.select();
    let ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    area.remove();
    return ok;
  }

  async function copyReference(trigger) {
    const value = (trigger.dataset.copyValue || '').trim();
    const toast = trigger.querySelector('.product-reference__toast-text');
    if (!value || !toast) return;

    let ok = false;
    try {
      await navigator.clipboard.writeText(value);
      ok = true;
    } catch (e) {
      ok = fallbackCopy(value);
    }

    // Annule les deux minuteurs d'un éventuel clic précédent
    clearTimeout(trigger._copyHideTimeout);
    clearTimeout(trigger._copyResetTimeout);

    trigger.classList.add('is-copied');
    toast.textContent = ok ? TEXT_DONE : TEXT_FAIL;

    trigger._copyHideTimeout = setTimeout(() => {
      trigger.classList.remove('is-copied');
      trigger._copyResetTimeout = setTimeout(() => {
        toast.textContent = TEXT_DEFAULT;
      }, 600);
    }, 1200);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.js-copy-reference');
    if (trigger) copyReference(trigger);
  });

  // Accessibilité : l'élément est un role="button" focusable → Entrée / Espace
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = event.target.closest('.js-copy-reference');
    if (!trigger) return;
    event.preventDefault(); // évite le défilement de la page avec Espace
    copyReference(trigger);
  });
})();